import { SectionId, V2 } from "@eventr/common";
import { routes } from "routing";
import { formatFlightNumber } from "v2/utils/flights";

/** An itinerary item a note can be attached to. */
export interface INoteItem {
  entryId: string;
  sectionId: number;
  title: string;
  path: string;
}

type TItem = Record<string, any> & { _id?: string };

/** Each section's item list, its name and its detail page. Section order is the summary's order. */
const SECTIONS: { id: SectionId; list: string; title: (item: TItem) => string; path: (item: TItem) => string }[] = [
  {
    id: SectionId.FLIGHT,
    list: "flights",
    title: (item) => (item.bookref ? formatFlightNumber(item.bookref) : ""),
    path: (item) => routes.item.flight.build({ itemId: item._id ?? "" }),
  },
  {
    id: SectionId.HOTEL,
    list: "hotels",
    title: (item) => item.name ?? "",
    path: (item) => routes.item.hotel.build({ itemId: item._id ?? "" }),
  },
  {
    id: SectionId.HIRE_CAR,
    list: "hireCars",
    title: (item) => item.car_alias ?? "",
    path: (item) => routes.item.hireCar.build({ itemId: item._id ?? "" }),
  },
  {
    id: SectionId.TRANSPORT,
    list: "transport",
    title: (item) => item.transport_alias ?? "",
    path: (item) => routes.item.transport.build({ itemId: item._id ?? "" }),
  },
  {
    id: SectionId.ACTIVITY,
    list: "activities",
    title: (item) => item.activity_name ?? item.todo_name ?? "",
    path: (item) =>
      item.type === "todo"
        ? routes.item.todo.build({ itemId: item._id ?? "" })
        : routes.item.activity.build({ itemId: item._id ?? "" }),
  },
  {
    id: SectionId.PARKING,
    list: "parkings",
    title: (item) => item.parking_name ?? "",
    path: (item) => routes.item.parking.build({ itemId: item._id ?? "" }),
  },
];

/** Every item in the itinerary a note can be attached to, in summary order. */
export const listNoteItems = (v2: V2[] | undefined): INoteItem[] => {
  const items: INoteItem[] = [];
  for (const section of SECTIONS) {
    const data = v2?.find((s) => s.sectionID === section.id)?.data;
    const list: TItem[] = Array.isArray(data?.[section.list]) ? data[section.list] : [];
    for (const item of list) {
      if (!item?._id) continue;
      items.push({ entryId: item._id, sectionId: section.id, title: section.title(item), path: section.path(item) });
    }
  }
  return items;
};
